import { Button, message, Popconfirm } from 'antd';
import React from 'react';
import { fetcher } from '../../../extras/fetcher';
import { DeleteOutlined } from '@ant-design/icons';
import { MessageInstance } from 'antd/es/message/interface';

interface Props {
  id: string;
  number: string;
  getData: () => void;
  messageApi:  MessageInstance;
}

export const DeleteForklift = (props: Props) => {



  const onConfirm = async (e?: React.MouseEvent) => {
    const {result, status} = await fetcher(`forklift/${props.id}`, 'DELETE');

    if(status === 204) {

      props.messageApi.open({
        type: 'success',
        content: `Wózek ${props.number} został usunięty!`,
      });

      props.getData();

      return;
    }

    props.messageApi.open({
      type: 'error',
      content: result.error ? result.error : 'Nieznany błąd!',
    });

  };

  return (<>
      <Popconfirm  placement="leftTop" title={`Na pewno chcesz usunąć wózek ${props.number}`} okText={'Tak'} cancelText={'Nie'}
                   onConfirm={onConfirm}>
        <Button icon={<DeleteOutlined />} />

      </Popconfirm>
    </>
  )

}
